import { type CommonAction, response } from "@iflyrpa/share";
import type { ActiomCommonParams, AxiosProxyParams, Xiaohongshu } from "../../types";
import { Http } from "../../utils/http";

export interface searchXiaohongshuLocationParams extends ActiomCommonParams {
    searchValue: string;
    latitude?: number;
    longitude?: number;
    size?: number;
    page?: number;
}

export type PublishAction = CommonAction<searchXiaohongshuLocationParams, Xiaohongshu.Location[]>;

export const searchXiaohongshuLocation: PublishAction = async (_task, params) => {
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://creator.xiaohongshu.com",
        origin: "https://creator.xiaohongshu.com",
    };
    const args: AxiosProxyParams = [{ headers }, _task.logger, params.proxyLoc, params.accountId];
    const http = new Http(...args);

    const result = await http.api<{ code: number; msg: string; data: { poi_list: Xiaohongshu.Location[] } }>(
        {
            method: "post",
            url: "https://edith.xiaohongshu.com/web_api/sns/v1/local/poi/creator/search",
            data: {
                keyword: params.searchValue,
                latitude: params.latitude ?? 0,
                longitude: params.longitude ?? 0,
                page: params.page ?? 1,
                size: params.size ?? 10,
                source: "WEB",
                type: 3,
            },
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = result.code === 0;
    const message = `获取地点信息${isSuccess ? "成功" : `失败，原因：${result.msg}`}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? result.data.poi_list : [];

    return response(isSuccess ? 0 : 414, message, data);
};
